import { GdprConsentsQueryApi } from 'graphql/generated';

export const getDefaultGdprConsents = (gdprConsents: GdprConsentsQueryApi['gdprConsents'] | undefined): string[] => {
    return gdprConsents?.filter((item) => item.isDefaultChecked).map((item) => item.type) ?? [];
};
